import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { UserContext } from '../context/User';
import { Button, Tooltip, Menu, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Navbar = ({ setActiveCalculator, logout }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState('home');
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const setStatus = useCallback(() => {
    let path = window.location.pathname.split('/');
    let calcType = path.find(p => p.includes('calculator'));

    if (calcType) {
      let type = calcType.replace('calculator', '');
      setActiveCalculator(type);
      setActiveButton(type);
    } else if (path.length === 1) {
      setActiveCalculator('home');
      setActiveButton('home');
    } else if (window.location.pathname === '/kci/admin/login/user') {
      setActiveCalculator('');
      setActiveButton('');
    } else if (window.location.pathname !== '/edit-profile') {
      setActiveCalculator('home');
      navigate('/');
      setActiveButton('home');
    }
  }, [navigate, setActiveCalculator]);

  useEffect(() => {
    setOpen(false);
    setStatus();
  }, [user, setStatus]);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  function handleClose(nav) {
    if (open && nav === true) {
      navigate('/kci/admin/login/user');
    }
    setOpen(!open);
  }

  return (
    <div className="navlinks">
      <div className="logo">
        <img
          src="https://img1.wsimg.com/isteam/ip/abd64615-a8ec-48d6-95cd-6499d9d91759/KCI%20Letter%20Logo.tiff/:/rs=w:649,h:150,cg:true,m/cr=w:649,h:150/qt=q:95"
          alt="Logo"
        />
      </div>

      <div className="navlinks-container">
        <button
          onClick={() => {
            navigate('/');
          }}
          className={activeButton === 'home' ? 'active' : ''}
        >
          Home
        </button>
        <button
          onClick={() => {
            navigate('deckcalculator');
          }}
          className={activeButton === 'deck' ? 'active' : ''}
        >
          Deck Calculator
        </button>
        <button
          onClick={() => {
            navigate('porchcalculator');
          }}
          className={activeButton === 'porch' ? 'active' : ''}
        >
          Porch Calculator
        </button>
        <button
          onClick={() => {
            navigate('carportcalculator');
          }}
          className={activeButton === 'carport' ? 'active' : ''}
        >
          Carport Calculator
        </button>
        <button
          onClick={() => {
            navigate('garagecalculator');
          }}
          className={activeButton === 'garage' ? 'active' : ''}
        >
          Garage Calculator
        </button>
      </div>
      {user && !user.isAnonymous && (
        <div className="navButtonGroup">
          <Tooltip title="View account info" placement="bottom" arrow>
            <Button color="error" variant="text" onClick={openMenu}>
              <AccountCircleIcon />
              {user.displayName || user.email}
            </Button>
          </Tooltip>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <MenuItem onClick={() => handleClose(true)}>Edit Profile</MenuItem>
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </div>
      )}
    </div>
  );
};

export default Navbar;